import { render, staticRenderFns } from "./scope65.vue?vue&type=template&id=8b4b3fb6&scoped=true"
import script from "./scope65.vue?vue&type=script&lang=js"
export * from "./scope65.vue?vue&type=script&lang=js"
import style0 from "./scope65.vue?vue&type=style&index=0&id=8b4b3fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4b3fb6",
  null
  
)

export default component.exports